<template>
	<div id="subpage_header">
		<div class="pagetitle"><slot></slot></div>
		<div class="backicon" @click.prevent="$emit('on-back')">
			<SvgCaretLeftFill></SvgCaretLeftFill>
		</div>
	</div>
</template>

<script>
	// SVG
	import SvgCaretLeftFill from '@/components/svg/caret-left-fill';

	export default {
		components: {
			SvgCaretLeftFill,
		},
		props: {
		},
		data() {
			return {
				showAccountInfo: false
			};
		},
		computed: {
			userName() {
				return this.$store.getters['commonStore/getUserName'];
			},
		},
		methods: {
			toggleAccountInfo() {
				this.showAccountInfo = !this.showAccountInfo;
			}
		},
		mounted() {
		}
	};
</script>

<style lang="scss" scoped>
	#subpage_header {
		position: relative;
		padding: 16px 0;
		margin: 0;
		border-bottom: solid 1px #ccc;
		text-align: center;
		.pagetitle {
			line-height: 1;
			font-size: 16ppx;
		}
		.backicon {
			cursor: pointer;
			position: absolute;
			left: 8px;
			top: 50%;
			width: 20px;
			height: 20px;
			margin-top: -10px;
			svg {
				width: 100%;
				height: 100%;
				vertical-align: top;
			}
		}
	}
</style>
